import { axios } from '@/utils/request'

export function getOSSInfoType(data) {
  return axios({
    url: '/admin/ossUpload?type=' + data.type,
    method: 'GET'
  })
}
export function getOSSInfoName(data) {
  return axios({
    url: '/admin/ossUpload?name=' + data.name,
    method: 'GET'
  })
}
